import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { uploadImagesAndSaveRecords } from '../../ImageSubmission/uploadForm';
import { deleteImagesFunction } from '../../../firebase/functions';
import '../../StaffGallery/StaffGallery.css';
import { allMonths } from '../CalendarEditor';
import { getNewYorkTimeZoneDate } from '../../../utils/dayjsUs';
const CalendarFrame = ({
  facilityId,
  claims,
  calendarFrameImages,
  userUid,
  setCalendarFrameImages,
  setIsLoading,
  getCalendarImages,
  facilityData,
  setFacilityData,
  month,
}) => {
  const [open, setOpen] = useState(false);
  const [openSelect, setOpenSelect] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); // State to hold multiple images
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]); // State to hold image preview URLs
  const [selectedMonth, setSelectedMonth] = useState(
    getNewYorkTimeZoneDate().format('MMMM'),
  );
  const [selectedImage, setSelectedImage] = useState(null);
  const [scope, setScope] = useState('global');
  // Handle dialog open
  const handleOpenDialog = () => {
    setOpen(true);
  };

  // Handle dialog close
  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedImages([]); // Reset image selection on close
    setImagePreviewUrls([]); // Reset previews on close
    setScope('global');
  };
  const handlClosechosedImage = () => {
    setOpenSelect(false);
    if (calendarFrameImages.length > 0 && facilityData?.calendarFrameImageId) {
      // Update selected image
      setSelectedImage(
        calendarFrameImages.find(
          (img) => img.id === facilityData?.calendarFrameImageId,
        ),
      );
    }
  };
  // Handle image selection (multiple)
  const handleImageSelect = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to an array
    setSelectedImages(files);

    // Generate preview URLs for each selected image
    const previewUrls = files.map((file) => URL.createObjectURL(file));
    setImagePreviewUrls(previewUrls);
  };

  // Handle save action
  const handleSave = async () => {
    if (selectedImages.length > 0) {
      handleCloseDialog();
      setIsLoading(true);
      await uploadImagesAndSaveRecords(
        {
          type: 'calendarFrame',
          month: selectedMonth,
          scope,
        },
        selectedImages,
        facilityId,
        userUid,
      );
      getCalendarImages();
      setIsLoading(false);
    } else {
      console.log('No images selected');
    }
  };

  const handlSaveSelectedImages = async (deletedImage) => {
    setIsLoading(true);

    try {
      // Check if facility document with the given facilityId exists
      const facilityQuery = query(
        collection(db, 'facilities'),
        where('facilityId', '==', facilityId),
        where('month', '==', month),
      );
      const querySnapshot = await getDocs(facilityQuery);

      if (!querySnapshot.empty) {
        // Facility exists, update the document
        querySnapshot.forEach(async (doc) => {
          const facilityDocRef = doc.ref;
          await updateDoc(facilityDocRef, {
            calendarFrameImage:
              selectedImage && !deletedImage ? selectedImage.imageUrl : null,
            calendarFrameImageId:
              selectedImage && !deletedImage ? selectedImage.id : null,

            month,
          });
        });
      } else {
        // Facility doesn't exist, create a new one
        await addDoc(collection(db, 'facilities'), {
          facilityId: facilityId,
          calendarFrameImage:
            selectedImage && !deletedImage ? selectedImage.imageUrl : null,
          calendarFrameImageId:
            selectedImage && !deletedImage ? selectedImage.id : null,

          month,
        });
      }

      // Update local state
      setFacilityData({
        ...facilityData,
        calendarFrameImage:
          selectedImage && !deletedImage ? selectedImage.imageUrl : null,
        calendarFrameImageId:
          selectedImage && !deletedImage ? selectedImage.id : null,
      });
    } catch (error) {
      console.error('Error updating facility:', error);
    } finally {
      setIsLoading(false);
      setOpenSelect(false);
    }
  };

  const handleChooseImage = (id) => {
    if (!selectedImage) {
      setSelectedImage(calendarFrameImages.find((img) => img.id === id));
    } else {
      setSelectedImage(null);
    }
  };
  const deleteSelectedImages = async () => {
    setOpenSelect(false);
    const imageUrls = [selectedImage?.imageUrl];

    if (
      !window.confirm(
        `Are you sure you want to delete the ${imageUrls.length} images you have selected below? This action is irreversible!`,
      )
    ) {
      return;
    }

    setIsLoading(true);
    try {
      // Delete images using the provided function
      await deleteImagesFunction({
        imageUrls: imageUrls,
        deleteFromFirestore: true,
      });

      // Update local state to remove deleted images
      setCalendarFrameImages(
        calendarFrameImages.filter((img) => !imageUrls.includes(img.imageUrl)),
      );

      // Query to find all facilities with the selected image ID
      const facilityQuery = query(
        collection(db, 'facilities'),
        where('calendarFrameImage', '==', imageUrls[0]), // Use imageIds[0] as it's the only selected image
      );

      const querySnapshot = await getDocs(facilityQuery);

      // Update all matching documents to set calendarFrameImage and calendarFrameImageId to null
      const updatePromises = querySnapshot.docs.map((doc) => {
        const facilityDocRef = doc.ref;
        return updateDoc(facilityDocRef, {
          calendarFrameImage: null,
          calendarFrameImageId: null,
        });
      });

      // Wait for all updates to complete
      await Promise.all(updatePromises);

      // Clear selected image if it was deleted
      if (imageUrls.includes(selectedImage?.id)) {
        setSelectedImage(null);
      }

      if (imageUrls.includes(facilityData?.calendarFrameImage)) {
        handlSaveSelectedImages(true);
      }
    } catch (error) {
      // Handle any errors that occurred during the delete or update operations
      console.error('Error deleting images:', error);
      // setErrorAlert(error.message || 'Failed to delete images');
    } finally {
      setIsLoading(false);
    }
  };
  const disabledCheckbox = (id) => {
    if (id === selectedImage?.id || !selectedImage) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    // Update selected image
    setSelectedImage(
      calendarFrameImages.find(
        (img) => img.id === facilityData?.calendarFrameImageId,
      ),
    );
  }, [facilityData, facilityId, calendarFrameImages]);
  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          Frame:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            width: 'auto',
            height: '100%',
            gap: 2,
            alignItems: 'start',
            padding: '14px 0',
            borderBottom: '4px solid black',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              height: '100%',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              width: '30%',
            }}
          >
            <Button
              variant="contained"
              sx={{
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                fontSize: 20,
                width: '100%',
              }}
              onClick={() => setOpenSelect(true)}
            >
              Modify
            </Button>
            {claims?.superadmin && (
              <Button
                variant="contained"
                onClick={handleOpenDialog}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 'bold',
                  fontSize: 20,
                  width: '100%',
                }}
              >
                Upload
              </Button>
            )}
          </Box>
          {facilityData && (
            <Box
              sx={{
                flexDirection: 'column',
                gap: 1,
                width: '70%',
                height: '100%',
              }}
            >
              {facilityData?.calendarFrameImage && (
                <img
                  src={facilityData?.calendarFrameImage}
                  alt={`Selected Calendar Frame`}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxHeight: '300px',
                    objectFit: 'contain',
                  }}
                />
              )}
            </Box>
          )}
        </Box>
      </Box>
      {/* Select Image Template Dialog */}
      <Dialog open={openSelect} onClose={handlClosechosedImage}>
        <DialogTitle>Select Frame</DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              paddingTop: 2,
            }}
          >
            {selectedImage && claims.superadmin && (
              <IconButton
                aria-label="delete image"
                onClick={deleteSelectedImages}
                sx={{
                  backgroundColor: '#004B8D',
                  color: 'white',
                  width: '150px',
                  borderRadius: 2,
                  fontSize: 25,
                  '&:hover': {
                    backgroundColor: '#808080',
                  },
                }}
              >
                <DeleteIcon />
                Delete
              </IconButton>
            )}
          </Box>
          <hr />
          {(() => {
            const globalFrames = calendarFrameImages.filter((img) => img.scope !== 'facility');
            const facilityFrames = calendarFrameImages.filter((img) => img.scope === 'facility');
            return (
              <>
                <Typography variant="subtitle1" fontWeight="bold" sx={{ mt: 1, mb: 1 }}>
                  Global Frames
                </Typography>
                {globalFrames.length > 0 ? (
                  <ImageList cols={3} variant="masonry" id="galleryContainer">
                    {Array.from(globalFrames).map((img, index) => (
                      <ImageListItem key={index}>
                        <img
                          src={img.imageUrl}
                          srcSet={img.imageUrl}
                          alt={img.residentId}
                          loading="lazy"
                          style={{
                            width: '100%',
                            height: '100%',
                            transition: 'opacity 0.4s ease',
                            opacity: selectedImage?.id === img.id ? 0.8 : 1,
                            ...(disabledCheckbox(img.id) ? { opacity: 0.2 } : {}),
                          }}
                        />
                        <Checkbox
                          checked={selectedImage?.id === img.id}
                          onChange={() => handleChooseImage(img.id)}
                          disabled={disabledCheckbox(img.id)}
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                ) : (
                  <Typography sx={{ mt: 1, mb: 2, color: 'gray', fontStyle: 'italic' }}>
                    No Global Frames For This Month
                  </Typography>
                )}

                <Box sx={{ my: 2, borderTop: '1px solid #ccc', pt: 2 }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    Facility-Specific Frames
                  </Typography>
                  {facilityFrames.length > 0 ? (
                    <ImageList cols={3} variant="masonry" id="galleryContainer">
                      {Array.from(facilityFrames).map((img, index) => (
                        <ImageListItem key={index}>
                          <img
                            src={img.imageUrl}
                            srcSet={img.imageUrl}
                            alt={img.residentId}
                            loading="lazy"
                            style={{
                              width: '100%',
                              height: '100%',
                              transition: 'opacity 0.4s ease',
                              opacity: selectedImage?.id === img.id ? 0.8 : 1,
                              ...(disabledCheckbox(img.id) ? { opacity: 0.2 } : {}),
                            }}
                          />
                          <Checkbox
                            checked={selectedImage?.id === img.id}
                            onChange={() => handleChooseImage(img.id)}
                            disabled={disabledCheckbox(img.id)}
                          />
                        </ImageListItem>
                      ))}
                    </ImageList>
                  ) : (
                    <Typography sx={{ mt: 1, mb: 2, color: 'gray', fontStyle: 'italic' }}>
                      No Facility-Specific Frames Uploaded for This Month
                    </Typography>
                  )}
                </Box>
              </>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
          <Button onClick={handlClosechosedImage}>Cancel</Button>
          <Button
            onClick={() => handlSaveSelectedImages(false)}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {/* Upload Template Dialog */}
      <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Upload Image Frames</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Image previews */}
            {imagePreviewUrls.length > 0 && (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  gap: 2,
                  mt: 2,
                }}
              >
                {imagePreviewUrls.map((url, index) => (
                  <img
                    key={index}
                    src={url}
                    alt={`Selected ${index}`}
                    style={{
                      maxWidth: '100px',
                      maxHeight: '100px',
                      borderRadius: '8px',
                      objectFit: 'cover',
                    }}
                  />
                ))}
              </Box>
            )}
            <Button variant="contained" component="label">
              Select Images
              <input
                type="file"
                accept="image/*"
                hidden
                multiple
                onChange={handleImageSelect} // Handle multiple image selection
              />
            </Button>
             <FormControl sx={{ minWidth: '200px' }}>
               <InputLabel id="selectLabel" shrink={true}>
                 Select Month
               </InputLabel>
               <Select
                 value={selectedMonth}
                 onChange={(e) => setSelectedMonth(e.target.value)}
                 displayEmpty
                 inputProps={{ 'aria-label': 'Resident selector' }}
                 sx={{ height: '46px' }}
                 labelId="selectLabel"
                 label="Select Month"
               >
                 {allMonths.map((month, index) => (
                   <MenuItem key={index} value={month}>
                     {month}
                   </MenuItem>
                 ))}
               </Select>
             </FormControl>
             <FormControl sx={{ minWidth: '200px' }}>
               <InputLabel id="scopeLabel" shrink={true}>
                 Availability Scope
               </InputLabel>
               <Select
                 value={scope}
                 onChange={(e) => setScope(e.target.value)}
                 displayEmpty
                 sx={{ height: '46px' }}
                 labelId="scopeLabel"
                 label="Availability Scope"
               >
                 <MenuItem value="global">Global (All Facilities)</MenuItem>
                 <MenuItem value="facility">Facility-Specific (Current Facility Only)</MenuItem>
               </Select>
             </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button
            disabled={selectedImages.length === 0}
            onClick={handleSave}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

CalendarFrame.propTypes = {
  facilityId: PropTypes.string,
  claims: PropTypes.object,
  calendarFrameImages: PropTypes.array,
  userUid: PropTypes.string,
  setCalendarFrameImages: PropTypes.func,
  setIsLoading: PropTypes.func,
  getCalendarImages: PropTypes.func,
  facilityData: PropTypes.object,
  setFacilityData: PropTypes.func,
  month: PropTypes.string,
};
export default CalendarFrame;
